import { AccountCreationConfigItem } from "./models/account-creation-config-item";
import { AccountCreationConfigurations } from "./models/account-creation-configurations";
import { DISALLOWED_WORDS_REGEX } from '../../core/models/disallowed-words';
import { ALLOWED_CHARACTERS_REGEX, ALLOWED_PASSWORD_CHARACTERS_REGEX, VALID_EMAIL_REGEX } from "../../core/models/account-management/account-regex";
import { COUNTRIES } from "../../core/models/countries";
import { STATES } from "../../core/models/states";
import { Component, OnInit, ViewChild, AfterViewInit, Input} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ApiConfig } from "../../core/api.service";
import { Ng2SelectMultiHelper } from '../../core/ng2-select-ext/ng2-select-multi-helper';
import { SelectComponent } from 'ng2-select/ng2-select';
import { AccountCreationService } from './services/account-creation.service';
import { FormControl } from '@angular/forms';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../login/services/authentication.service';
import { HttpParams } from "@angular/common/http";
import { Validation } from './models/validation';
import { Inject } from '@angular/core';
import { BasicAccountInfo } from '../../core/models/account-management/basic-account-info';

var userId: any;
declare var $: any;
declare var XapEmailValidate: any;


@Component({
    selector: 'account-creation-app',
    
    templateUrl: 'account-creation.component.html',
    styleUrls: ['account-creation.component.css'],
    providers: [AuthenticationService]
})
export class AccountCreationComponent implements OnInit {
    @ViewChild('selectedSchoolRaw') selectedSchoolRaw: SelectComponent;
    @ViewChild('selectedCountryRaw') selectedCountryRaw: SelectComponent;
    @ViewChild('selectedStateRaw') selectedStateRaw: SelectComponent;
    @ViewChild('mailingSelectedCountryRaw') mailingSelectedCountryRaw: SelectComponent;
    @ViewChild('mailingSelectedStateRaw') mailingSelectedStateRaw: SelectComponent;

    @Input()
    AccountRecoveryURL: string;
    currentSystemName: string;
   
    sessionVariables: any;

    constructor(private router: Router, 
        private accountCreationService: AccountCreationService, 
        private authService: AuthenticationService,
        @Inject('AppData') appData) {
      this.apiConfigInstance.setSession(appData);
       this.currentSystemName =this.apiConfigInstance.getSession().systemInfo.currentSystemName;
      //var session = this.savColService.getSession();
            //this.apiConfigInstance.setUser(user);
          //  console.log(appData.systemInfo.apiToken);
    }
    private apiConfigInstance = ApiConfig.getInstance();

    //configurationItemList: AccountCreationConfigItem[];
    config: AccountCreationConfigurations = new AccountCreationConfigurations();
    selectedRole: string;
    dateMask: any = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    phoneMask: any = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    schoolPickerHelper: Ng2SelectMultiHelper = new Ng2SelectMultiHelper();
    countryPickerHelper: Ng2SelectMultiHelper = new Ng2SelectMultiHelper();
    statePickerHelper: Ng2SelectMultiHelper = new Ng2SelectMultiHelper();
    mailingCountryPickerHelper: Ng2SelectMultiHelper = new Ng2SelectMultiHelper();
    mailingStatePickerHelper: Ng2SelectMultiHelper = new Ng2SelectMultiHelper();
    //schoolChoice: any[];
    countryChoices: any[];
    stateChoices: any[];
    SchoolList: any[];
    isValidLicence: boolean = true;
    // ethnicity checkboxes
    native: any;
    asian: any;
    africanAmerican: any;
    hawaiian: any;
    white: any;
    middleNameValue: string;
    accountNameValue: string;
    passwordValue: string;
    passwordConfirmationValue: string;
    emailConfirmationValue: string;
    sexValue: string;
    ethnicity: string;
    dateOfBirthValue: string;
    internationalPostalCodeValue: string;
    selectedRoleValue: string;
    selectedRoleId: number;
    studentStateId: string;
    gradYearValue: string;
    securityQuestionValue: string;
    referredByModel: string;
    inviteInfo: any;
    personalInfoSharing: any;

    securityAnswerValue: string;
    accountNameForm = new FormControl();
    passwordForm = new FormControl();
    emailForm = new FormControl();
    dateOfBirthForm = new FormControl();
    addressValue: string;
    cityValue: string;
    zipValue: string;
    countyValue: string;
    ethnicityForm = new FormControl();
    nativeForm = new FormControl();
    asianForm = new FormControl();
    africanAmericanForm = new FormControl();
    hawaiianForm = new FormControl();
    whiteForm = new FormControl();
    choicesNameForm = new FormControl();
    choicesPasswordForm = new FormControl();

    validation: Validation = new Validation();
    VALID_EMAIL_REGEX: any = VALID_EMAIL_REGEX;
    tempEmail: string;

    RolesEnum: any = {
        MiddleSchool: 'ms',
        HighSchool: 'hs',
        PostSecondary: 'c',
        Adult: 'a',
        Parent: 'p'
    }

    choicesUsernameError: boolean = false;
    choicesPasswordError: boolean = false;
    schoolSelectorTouched: boolean = false;
    isCoppaRestricted: boolean = false;
    selectedSchool: any;
    selectedState: any;
    selectedCountry: any;
    emailValue: string;
    cellphone: string;
    isCellPhoneValid: boolean = false;
    cellPhoneValidated: boolean = false;
    mobileOptInCheckbox: boolean = false;
    displayValidationError: boolean = false;
    validationCode: string;
    userValidationCode: string;
    enableMobileValidationButton: boolean = false;
    displayValidationTextbox: boolean = false;
    StudentData: any;

    isCodeActivated: boolean = false;

    isInvalidActivationCode: boolean = false;

    invalidForm: boolean = false;
    isPopulated: boolean = false;

    isSetSystemKeyFalse: boolean = false;
    currentDate: Date = new Date();

    applicationId: number = -1;
    systemId: number;
    currentSiteType: number;
    selectedResourceId: number;
    defaultResourceId: number;
    providedResourceId: number;

    socialsignin: any;
    systemKey: string;
    domain: string;
    isExistingUser: boolean = false;
    existingUserId: number;

    hideNames: boolean = false;
    firstNameValue: string;
    lastNameValue: string;
    vawizardInfo: any;
    nextpage: string;
    isPrivacyPolicy: boolean = true;

    privacyLink: HTMLAnchorElement;
    termsLink: HTMLAnchorElement;

    c2cId: string;
    referrerUrl: string;
    howHearAllowedDomain: string;
    howHearGenerateID: boolean = false;
    howHearSendToXap: boolean = false;
    howHearDisabled: boolean = false;
    loginSource: string;

    gradYearRange: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    // ddDateYear: number = this.getDDDateYear();
    useSiteChecked : boolean = false;
    dobThirteen: string = this.createDate(0, 0, -13).toJSON().split('T')[0];
    invited: boolean = false; 
    isVccs: boolean = false;
   

    createDate(days, months, years): Date {
        var date = new Date();
        date.setDate(date.getDate() + days);
        date.setMonth(date.getMonth() + months);
        date.setFullYear(date.getFullYear() + years);
        return date;
    }   

    ngOnInit(): void {       
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
          document.body.scrollTop = 0;
          this.isVccs = (this.apiConfigInstance.getSession().systemInfo.currentSystemId == 88) ? true : false;
        
        });

        var apiConfigInstance = ApiConfig.getInstance();
        this.sessionVariables = apiConfigInstance.getSession();
        
        this.apiConfigInstance.setApiToken(this.sessionVariables.systemInfo.apiToken)
        this.systemId = this.sessionVariables.systemInfo.currentSystemId;
        this.currentSiteType =  this.sessionVariables.systemInfo.currentSiteTypeId;

        this.applicationId =  this.sessionVariables.systemInfo.currentApplicationId;
        this.providedResourceId =  this.sessionVariables.systemInfo.currentProvidedResourceId;

        if ( this.sessionVariables.systemInfo.socialsignin) {
            this.socialsignin =  this.sessionVariables.systemInfo.socialsignin
        }

        if ( this.sessionVariables.systemInfo.existingUserName &&  this.sessionVariables.systemInfo.existingUserName != "") {
            this.isExistingUser = true;
        }

        //console.log(sessionVariables);
        this.vawizardInfo =  this.sessionVariables.systemInfo.vawizardInfo;
        this.nextpage =  this.sessionVariables.nextpage;
        this.c2cId =  this.sessionVariables.c2cId;
        this.referrerUrl = this.sessionVariables.referrerUrl;
        var configList: AccountCreationConfigItem[];

        // set the drop dpwns to the placeholder text option
        this.sexValue = "-1";
        this.ethnicity = "-1";
        this.selectedRoleValue = "-1";
        this.gradYearValue = "-1";
        this.securityQuestionValue = "-1";
        this.referredByModel = "-1";

        //this.schoolPickerHelper.initialize([{ label: 'test', value: 'test' }, { label: 'abcde', value: 'abcde' }, { label: 'asdf', value: 'asdf' }], []);

        this.accountCreationService.getConfigList(this.applicationId).subscribe((output) => {
            configList = output.ConfigItemList;
            //TODO: will need to make this selection contingent on whether or not we show userrole / whether or not there is a default role
            this.selectedRoleValue = output.DefaultRole;
            this.howHearAllowedDomain = output.AllowedDomain;
            this.howHearGenerateID = output.GenerateID;
            this.howHearSendToXap = output.SendToXap;

            //TODO: will need to make this also something that is based of a configuration
            this.selectedResourceId = output.DefaultResourceId;
            this.defaultResourceId = output.DefaultResourceId;              

            this.populateConfig(configList);

            if ( this.sessionVariables.systemInfo.groupId &&  this.sessionVariables.systemInfo.groupId != "") {
                this.config.SystemKey.Required = false
                this.config.SystemKey.Visible = false
                this.isCodeActivated = true;
            }
            
            this.domain = output.Domain;

            if ( this.sessionVariables.systemInfo.existingUserName &&  this.sessionVariables.systemInfo.existingUserName != "") {
                this.disableSystemKey()
                this.accountCreationService.getExistingUser( this.sessionVariables.systemInfo.existingUserName,  this.sessionVariables.systemInfo.existingPassword,  this.sessionVariables.systemInfo.apiToken).subscribe((output) => {
                   // console.log(output)
                    this.StudentData = output;
                    this.sexValue = output.Gender == null ? -1 : output.Gender
                    this.ethnicity = output.Ethnicity == null ? -1 : output.Ethnicity
                    this.securityQuestionValue = output.SecurityQuestion == null ? -1 : output.SecurityQuestion
                    this.securityAnswerValue = output.SecurityAnswer;
                    this.selectedResourceId = output.UserResourceId;
                    this.cellphone = output.CellPhone;
                    this.dateOfBirthValue = output.DOB == null ? "" : this.convertDate(output.DOB);
                    this.middleNameValue = output.MiddleName;
                    this.accountNameValue = output.Username;
                    this.firstNameValue = output.FirstName;
                    this.lastNameValue = output.LastName;
                    this.emailConfirmationValue = output.Email;
                    this.emailValue = output.Email;
                    this.referredByModel = output.HowHear < 1 ? null : output.HowHear;
                    this.personalInfoSharing = output.OptIn;
                    this.passwordValue = output.Password;
                    this.passwordConfirmationValue = output.Password;

                    this.tempEmail = output.Email;
                    if (output.UserAddress) {
                        this.cityValue = output.UserAddress.AddressCity
                        this.selectedCountry = output.UserAddress.AddressCountry
                        this.countyValue = output.UserAddress.AddressCounty;
                        this.addressValue = output.UserAddress.AddressStreet1
                        this.selectedState = output.UserAddress.AddressState
                        this.zipValue = output.UserAddress.AddressZip
                        this.internationalPostalCodeValue = output.UserAddress.AddressIntlCode
                    }

                    this.mobileOptInCheckbox = output.MobileOptIn;
                    this.existingUserId = output.UserId;
                    this.selectedRoleId = output.RoleId;
                    switch (output.RoleId) {
                        case 1:
                            this.selectedRoleValue = this.RolesEnum.MiddleSchool
                            break
                        case 2:
                            this.selectedRoleValue = this.RolesEnum.HighSchool
                            break
                        case 3:
                            this.selectedRoleValue = this.RolesEnum.PostSecondary
                            break
                        case 4:
                            this.selectedRoleValue = this.RolesEnum.Adult
                            break
                        case 5:
                            this.selectedRoleValue = this.RolesEnum.Parent
                            break
                    }
                    this.gradYearValue = output.YearOfGraduation == null ? -1 : this.getGradeYearByGradYear(output.YearOfGraduation);
                    this.populateResouce(output.UserResourceId);
                    this.isPopulated = true;
                   
                    this.configureConfig(false)
                    
                    this.hideAditionPanel();
                    this.populateCountry();
                    this.populateState();                   
                });
            }
            else if ( this.sessionVariables.systemInfo.inviteInfo &&  this.sessionVariables.systemInfo.inviteInfo != null)
            {
                this.invited = true ; 
                this.disableSystemKey()
                this.inviteInfo =  this.sessionVariables.systemInfo.inviteInfo;
                this.selectedRoleValue = this.RolesEnum.Parent
                this.selectedRoleId = 5;  // Parent
                this.selectedResourceId =  this.sessionVariables.systemInfo.inviteInfo.userresourceid
                this.firstNameValue =  this.sessionVariables.systemInfo.inviteInfo.parentfirstname
                this.lastNameValue =  this.sessionVariables.systemInfo.inviteInfo.parentlastname
                this.emailValue =  this.sessionVariables.systemInfo.inviteInfo.parentemail
                this.emailConfirmationValue =  this.sessionVariables.systemInfo.inviteInfo.parentemail
                this.populateResouce( this.sessionVariables.systemInfo.inviteInfo.userresourceid);
                this.isPopulated = true;
                this.hideAditionPanel();
                this.populateCountry();
                this.populateState();
            }
            else {
                if (!this.selectedRoleValue)
                    this.selectedRoleValue = "-1"

                if (this.config.UserRole && this.config.UserRole.Visible == false) {
                    this.selectedRoleId = 0;
                    this.refreshSchoolList();
                }

                this.populateCountry();
                this.populateState();
                this.isPopulated = true;
                this.hideAditionPanel();
            }

            this.accountCreationService.getEmailSettings(this.applicationId).subscribe((output) => {
                this.loadEmailValidation(output.productName, output.accessKey, output.codeKey, output.resendTimeSpan);
            });
                  
        });

        // the privacy and terms html links can be overidden and set at the system level (like for transcript ordering portal - sys id 7)
        this.accountCreationService.getSystemCreateAccountConfigItem('PrivacyLink').subscribe((output) => {
            if (output.Text) {                
                this.setPrivacyTermsLink(output.Text, 'privacylink');
            }
        });

        this.accountCreationService.getSystemCreateAccountConfigItem('TermsLink').subscribe((output) => {
            if (output.Text) {                
                this.setPrivacyTermsLink(output.Text, 'termslink');
            }
        });
    }

    configureConfig(isRefresh:boolean ) {
        if (this.config.AccountName && (this.isValueExist(this.accountNameValue) || this.config.AccountName.Required == false)) this.config.AccountName.Visible = false;
       // if (!isRefresh) {
            if (this.config.UserRole && (this.isValueExist(this.selectedRoleValue) || this.config.UserRole.Required == false)) this.config.UserRole.Visible = false;
      //  }
        if (this.config.SelectSchool && ((this.isValueExist(this.selectedResourceId) && this.selectedResourceId != -2147483648) || this.config.SelectSchool.Required == false)) this.config.SelectSchool.Visible = false;
        if (this.config.MiddleName && (this.isValueExist(this.middleNameValue) || this.config.MiddleName.Required == false)) this.config.MiddleName.Visible = false;
       // if (this.config.DateOfBirth && (this.isValueExist(this.dateOfBirthValue) || this.config.DateOfBirth.Required == false || this.config.DateOfBirth.Roles.indexOf(this.selectedRoleValue) == -1)) this.config.DateOfBirth.Visible = false;
        if (this.config.DateOfBirth && ((this.isValueExist(this.dateOfBirthValue) && isRefresh == false) || this.config.DateOfBirth.Required == false || this.config.DateOfBirth.Roles.indexOf(this.selectedRoleValue) == -1)) {
          this.config.DateOfBirth.Visible = false;
        }
        else {
          if (this.config.DateOfBirth && this.config.DateOfBirth.Visible == false
            && this.isValueExist(this.dateOfBirthValue) == false && this.config.DateOfBirth.Required == true && this.config.DateOfBirth.Roles.indexOf(this.selectedRoleValue) > -1) {
            this.config.DateOfBirth.Visible = true;
          }
        }

        if (this.config.Cellphone && (this.isValueExist(this.cellphone) || this.config.Cellphone.Required == false)) this.config.Cellphone.Visible = false;

        if (this.config.MobileOptIn && (this.isValueExist(this.mobileOptInCheckbox) || this.config.MobileOptIn.Required == false)) this.config.DateOfBirth.Visible = false;

        if (this.config.GradYear && this.config.GradYear.Roles.indexOf(this.selectedRoleValue) > -1) {
            this.config.GradYear.Required = true
            this.config.GradYear.Visible = true;
        }
        if (this.config.GradYear && (this.gradYearValue != "-1" || this.config.GradYear.Required == false))
            this.config.GradYear.Visible = false;

        if (this.config.FirstName && (this.isFirstNameExist(this.firstNameValue) || this.config.FirstName.Required == false)) this.config.FirstName.Visible = false;
        if (this.config.LastName && (this.isLastNameExist(this.lastNameValue, this.firstNameValue, this.accountNameValue) || this.config.LastName.Required == false)) this.config.LastName.Visible = false;

        if (this.config.FirstName.Visible) this.firstNameValue = "";
        if (this.config.LastName.Visible) this.lastNameValue = "";


        if (this.config.PermanentAddress && (this.isValueExist(this.addressValue) || this.config.PermanentAddress.Required == false)) this.config.PermanentAddress.Visible = false;
        if (this.config.EmailConfirmation != null && (this.isValueExist(this.emailValue))) this.config.EmailConfirmation.Visible = false;
        if (this.config.EmailValidate && (this.isValueExist(this.emailValue) || this.config.EmailValidate.Required == false)) this.config.EmailValidate.Visible = false;

        if (this.config.Email && (this.isValueExist(this.emailValue) || this.config.Email.Required == false)) this.config.Email.Visible = false;

        //if (this.config.AddressPanel && this.isValueExist(this.gradYearValue)) this.config.AddressPanel.Visible = false;
        //if (this.config.AdditionalInformationPanel && this.isValueExist(this.gradYearValue)) this.config.AdditionalInformationPanel.Visible = false;

        if (this.config.EmailValidate && (this.isValueExist(this.emailValue) || this.config.EmailValidate.Required == false)) this.config.EmailValidate.Visible = false;
        if (this.config.HowHear && (this.isValueExist(this.referredByModel) || this.config.HowHear.Required == false)) this.config.HowHear.Visible = false;

        if (this.config.Ethnicity && (this.isValueExist(this.ethnicity == "-1" ? "" : this.ethnicity) || this.config.Ethnicity.Required == false)) this.config.Ethnicity.Visible = false;
        if (this.config.Sex && (this.isValueExist(this.sexValue == "-1" ? "" : this.sexValue) || this.config.Sex.Required == false)) this.config.Sex.Visible = false;
        if (this.config.SecurityQuestion && (this.isValueExist(this.securityQuestionValue == "-1" ? "" : this.securityQuestionValue) || this.config.SecurityQuestion.Required == false)) this.config.SecurityQuestion.Visible = false;

        if (this.config.SecurityAnswer && (this.isValueExist(this.securityAnswerValue) || this.config.SecurityAnswer.Required == false)) this.config.SecurityAnswer.Visible = false;
        if (this.config.Password && (this.isValueExist(this.passwordValue) || this.config.Password.Required == false)) this.config.Password.Visible = false;
        if (this.config.PasswordConfirmation && (this.isValueExist(this.passwordConfirmationValue) || this.config.PasswordConfirmation.Required == false)) this.config.PasswordConfirmation.Visible = false;

        //if (this.config.Religion && this.isValueExist(this.gradYearValue)) this.config.Religion.Visible = false;
        //if (this.config.Ssn && this.isValueExist(this.gradYearValue)) this.config.Ssn.Visible = false;

        if (this.config.Country && this.config.Country.Required == false) this.config.Country.Visible = false;
        if (this.config.City && (this.isValueExist(this.cityValue) || this.config.City.Required == false)) this.config.City.Visible = false;
        if (this.config.County && (this.isValueExist(this.countyValue) || this.config.County.Required == false)) this.config.County.Visible = false;
        if (this.config.InternationalPostalCode && (this.isValueExist(this.internationalPostalCodeValue) || this.config.InternationalPostalCode.Required == false)) this.config.InternationalPostalCode.Visible = false;
        if (this.config.PersonalInfoSharing && (this.isValueExist(this.personalInfoSharing) || this.config.PersonalInfoSharing.Required == false)) this.config.PersonalInfoSharing.Visible = false;
        if (this.config.State && (this.isValueExist(this.selectedState) || this.config.State.Required == false)) this.config.State.Visible = false;
        if (this.config.Street && (this.isValueExist(this.addressValue) || this.config.Street.Required == false)) this.config.Street.Visible = false;
        if (this.config.StudentStateId && (this.isValueExist(this.studentStateId) || this.config.StudentStateId.Required == false)) this.config.StudentStateId.Visible = false;
        if (this.config.Zipcode && (this.isValueExist(this.zipValue) || this.config.Zipcode.Required == false)) this.config.Zipcode.Visible = false;

        //  let params = new HttpParams().getAll (window.location.search.toLocaleLowerCase());
        let params = new HttpParams({ fromString: window.location.search.toLocaleLowerCase().split('?')[1] })
        let someParam = params.get("missinginfo")
        let someParam1 = params.get("missinginfo")
        this.loginSource = params.get("rsrc");

        this.checkCoppaDate();

        if (this.StudentData) {
            let privacyPolicy = this.convertDate(this.StudentData.PrivacyPolicy);
            if (privacyPolicy && privacyPolicy != "") {
                this.isPrivacyPolicy = false;
            }
        }

        if (someParam == "password" || someParam1 == "password") {
            this.passwordValue = "";
            this.passwordConfirmationValue = "";
            this.config.Password.Visible = true;
            this.config.PasswordConfirmation.Visible = true;
        }

        if (someParam == "privacypolicy" || someParam1 == "privacypolicy") {
            this.isPrivacyPolicy = true;

            if (this.StudentData && !this.StudentData.IsAutoLoaded)
                this.config.ImportChoices.Visible = false;
        }

        if (someParam == "resource" || someParam1 == "resource") {
            this.selectedResourceId = null;
            this.config.SelectSchool.Visible = true;
        }
    }

    hideAditionPanel() {
        if (this.config.AdditionalInformationPanel && this.config.AdditionalInformationPanel.Visible) {
            if (!(this.config.PersonalInfoSharing && this.config.PersonalInfoSharing.Visible) &&
                !(this.config.Coppa && this.config.Coppa.Visible) &&
                !(this.config.Ssn && this.config.Ssn.Visible) &&
                !(this.config.Citizen && this.config.Citizen.Visible) &&
                !(this.config.HowHear && this.config.HowHear.Visible) &&
                !(this.config.Religion && this.config.Religion.Visible) &&
                !(this.config.Sex && this.config.Sex.Visible))
                this.config.AdditionalInformationPanel.Visible = false;
        }
        
        if(this.config.AddressPanel && this.config.AddressPanel.Visible 
            && !(this.config.City && this.config.City.Visible )
            && !(this.config.State && this.config.State.Visible  )
            && !(this.config.Zipcode && this.config.Zipcode.Visible )
            && !(this.config.InternationalPostalCode && this.config.InternationalPostalCode.Visible)
            && !(this.config.Country && this.config.Country.Visible )
            && !(this.config.County && this.config.County.Visible )) 
            this.config.AddressPanel.Visible = false;

    }

    isValueExist(dataValue: any): boolean {
        if (dataValue && dataValue != "") {
            return true;
        }
        return false;
    }

    isFirstNameExist(firstName: string): boolean {

        const reservedFirstName: string = 'coppa restricted';
        let valueExist: boolean = this.isValueExist(firstName);

        if ((valueExist && this.isAboveThirteen()) || this.config.CoppaRestricted.Required == false) {
            if (firstName.toLowerCase() == reservedFirstName) {
                valueExist = false;
            }
        }
        return valueExist
    }

    isLastNameExist(lastName: string, firstName: string, username: string): boolean {
        let valueExist: boolean = this.isValueExist(lastName);
        if (!valueExist) return valueExist;

        if (lastName != username) return valueExist;

        return this.isFirstNameExist(firstName);
    }

    disableSystemKey() {
        if (this.config.SystemKey && this.config.SystemKey.Visible) {
            this.config.SystemKey.Visible = false;
            this.config.SystemKey.Required = false;
            this.isSetSystemKeyFalse = true;
        }
    }

    populateResouce(resouceid: string) {
        if (this.selectedResourceId && this.isSetSystemKeyFalse) {
            this.accountCreationService.GetSchoolInfo(resouceid).subscribe((schoolInfo) => {
                if (schoolInfo.GroupId && schoolInfo.GroupId != "") {
                    this.accountCreationService.SetGroupID(schoolInfo.GroupId).subscribe((schoolInfo) => {
                        this.config.SystemKey.Visible = false;
                        this.config.SystemKey.Required = false;
                        this.refreshSchoolList();
                    });
                }
                else {
                    if (this.isSetSystemKeyFalse) {
                        this.config.SystemKey.Visible = true;
                        this.config.SystemKey.Required = true;
                    }
                    else
                        this.refreshSchoolList();
                }
            });
        }
        else {
            if (this.isSetSystemKeyFalse) {
                this.config.SystemKey.Visible = true;
                this.config.SystemKey.Required = true;
            }
            else
            {
                this.refreshSchoolList();
            }
        }
    }

    populateState() {
        if (this.selectedState) {
            var mapitem = [];
            mapitem.push(this.selectedState);


            var selectedState = STATES.find(entry => {
                return entry.value == this.selectedState;
            });
            if (selectedState) {
                this.statePickerHelper.initialize(STATES, mapitem);
            }
            else {
                this.statePickerHelper.initialize(STATES, []);
            }

        } else {
            this.statePickerHelper.initialize(STATES, []);
        }
    }

    populateCountry() {
        if (this.selectedCountry) {
            var mapitem = [];
            mapitem.push(this.selectedCountry);

            var selectedCountry = COUNTRIES.find(entry => {
                return entry.value == this.selectedCountry;
            });
            if (selectedCountry) {
                this.countryPickerHelper.initialize(COUNTRIES, mapitem);
            }
            else {
                this.countryPickerHelper.initialize(COUNTRIES, []);
            }

        } else {
            this.countryPickerHelper.initialize(COUNTRIES, []);
        }
    }

    ngAfterViewInit() {

        this.schoolPickerHelper.setComponent(this.selectedSchoolRaw);
        this.countryPickerHelper.setComponent(this.selectedCountryRaw);
        this.statePickerHelper.setComponent(this.selectedStateRaw);
        this.mailingCountryPickerHelper.setComponent(this.mailingSelectedCountryRaw);
        this.mailingStatePickerHelper.setComponent(this.mailingSelectedStateRaw);
    }

    convertDate(dateval: string): string {
        let dateValue = "";
        let temdate: any = dateval.split('-');
        if (temdate[0] == "0001")
            dateValue = null;
        else
            dateValue = temdate[1] + "/" + temdate[2].substring(0, 2) + "/" + temdate[0];

        return dateValue
    }

    getConfigItemByKey(key: string, configList: AccountCreationConfigItem[]): AccountCreationConfigItem {

        for (let config of configList) {
            if (config.Name == key) {
                return config;
            }

        }

        return null;
    }

    refreshSchoolList() {
        this.accountCreationService.getSchoolListUpdated(this.selectedRoleId).subscribe((output) => {
            this.SchoolList = output;
            
            if (this.selectedResourceId) {
                var mapitem = [];
                mapitem.push(this.selectedResourceId);

                var selectedResource = output.find(entry => {
                    return entry.Id == this.selectedResourceId;
                });

                if (selectedResource) {
                    this.schoolPickerHelper.initialize(this.populateTypeAheadSchoolArray(output), mapitem);
                }
                else {
                    this.schoolPickerHelper.initialize(this.populateTypeAheadSchoolArray(output), []);
                }
            }
            else
                this.schoolPickerHelper.initialize(this.populateTypeAheadSchoolArray(output), []);
        });
    }

    refreshConfigList() {

        this.accountCreationService.getConfigList(this.applicationId).subscribe((output) => {
            var configList = output.ConfigItemList;

            this.populateConfig(configList);

            if (this.StudentData)
                this.configureConfig(true)
        });
    }

    populateConfig(configList: AccountCreationConfigItem[]) {
        this.config = {
            SystemKey: this.getConfigItemByKey('SystemKey', configList),
            UserRole: this.getConfigItemByKey('UserRole', configList),
            SelectSchool: this.getConfigItemByKey('SelectSchool', configList),
            SchoolNotInList: this.getConfigItemByKey('SchoolNotInList', configList),
            MiddleName: this.getConfigItemByKey('MiddleName', configList),
            DateOfBirth: this.getConfigItemByKey('DateOfBirth', configList),
            Cellphone: this.getConfigItemByKey('Cellphone', configList),
            MobileOptIn: this.getConfigItemByKey('MobileOptIn', configList),
            UseXapEmail: this.getConfigItemByKey('UseXapEmail', configList),
            DayPhone: this.getConfigItemByKey('DayPhone', configList),
            EveningPhone: this.getConfigItemByKey('EveningPhone', configList),
            PermanentAddress: this.getConfigItemByKey('PermanentAddress', configList),
            GradYear: this.getConfigItemByKey('GradYear', configList),
            EmailConfirmation: this.getConfigItemByKey('EmailConfirmation', configList),
            EmailValidate: this.getConfigItemByKey('EmailValidate', configList),
            FirstName: this.getConfigItemByKey('FirstName', configList),
            LastName: this.getConfigItemByKey('LastName', configList),
            Email: this.getConfigItemByKey('Email', configList),
            AccountName: this.getConfigItemByKey('AccountName', configList),
            Password: this.getConfigItemByKey('Password', configList),
            PasswordConfirmation: this.getConfigItemByKey('PasswordConfirmation', configList),
            SecurityQuestion: this.getConfigItemByKey('SecurityQuestion', configList),
            SecurityAnswer: this.getConfigItemByKey('SecurityAnswer', configList),
            AddressPanel: this.getConfigItemByKey('AddressPanel', configList),
            Street: this.getConfigItemByKey('Street', configList),
            City: this.getConfigItemByKey('City', configList),
            State: this.getConfigItemByKey('State', configList),
            Zipcode: this.getConfigItemByKey('Zipcode', configList),
            County: this.getConfigItemByKey('County', configList),
            Country: this.getConfigItemByKey('Country', configList),
            InternationalPostalCode: this.getConfigItemByKey('InternationalPostalCode', configList),
            AdditionalInformationPanel: this.getConfigItemByKey('AdditionalInformationPanel', configList),
            AccountSecurityPanel: this.getConfigItemByKey('AccountSecurityPanel', configList),
            ImportChoices: this.getConfigItemByKey('ImportChoices', configList),
            PersonalInfoSharing: this.getConfigItemByKey('PersonalInfoSharing', configList),
            Coppa: this.getConfigItemByKey('Coppa', configList),
            Sex: this.getConfigItemByKey('Sex', configList),
            Ethnicity: this.getConfigItemByKey('Ethnicity', configList),
            HowHear: this.getConfigItemByKey('HowHear', configList),
            MailingAddressPanel: this.getConfigItemByKey('MailingAddressPanel', configList),
            MailingStreet: this.getConfigItemByKey('MailingStreet', configList),
            MailingCity: this.getConfigItemByKey('MailingCity', configList),
            MailingState: this.getConfigItemByKey('MailingState', configList),
            MailingZipcode: this.getConfigItemByKey('MailingZipcode', configList),
            MailingCounty: this.getConfigItemByKey('MailingCounty', configList),
            MailingCountry: this.getConfigItemByKey('MailingCountry', configList),
            MailingInternationalPostalCode: this.getConfigItemByKey('MailingInternationalPostalCode', configList),
            Religion: this.getConfigItemByKey('Religion', configList),
            Ssn: this.getConfigItemByKey('Ssn', configList),
            StudentStateId: this.getConfigItemByKey('StudentStateId', configList),
            Citizen: this.getConfigItemByKey('Citizen', configList),
            CoppaRestricted: this.getConfigItemByKey('CoppaRestricted', configList),
            BadEmailDomain: this.getConfigItemByKey('BadEmailDomain', configList)

        }

        if (this.config.HowHear && this.config.HowHear.Visible)
        {
            if (this.config.HowHear.Text && this.config.HowHear.Text != "") {
                
                if (this.systemId == 88) {
                    var hostname = this.extractHostname(this.referrerUrl);
                    if (this.c2cId != "" && this.howHearSendToXap && this.howHearAllowedDomain.indexOf(hostname) > -1) {
                        var howHearText = '[{ "value": "301", "name": "Credits2Careers (C2C)" }]';
                        this.config.HowHear.Text = JSON.parse(howHearText);
                        this.referredByModel = "301";
                        this.howHearDisabled = true;
                      
                    }
                    else {
                        this.config.HowHear.Text = JSON.parse(this.config.HowHear.Text);
                    }
                }
                else {
                    this.config.HowHear.Text = JSON.parse(this.config.HowHear.Text);
                }
            }
        }

        if (this.socialsignin && this.socialsignin.userid != "") {
            this.hideNames = true;
            this.firstNameValue = this.socialsignin.firstname;
            this.lastNameValue = this.socialsignin.lastname;
            this.config.MiddleName = null;
            this.config.AccountName = null;
            this.config.Password = null;
            this.config.PasswordConfirmation = null;
            this.config.SecurityQuestion = null;
            this.config.SecurityAnswer = null;
            this.dateOfBirthValue = this.socialsignin.dob;

            if (this.socialsignin.email != "" && this.socialsignin.email != "undefined") {
                this.config.Email = null;
                this.config.EmailValidate = null;
                this.config.EmailConfirmation = null;
                this.config.UseXapEmail = null;
            }
        }

        if (this.vawizardInfo && this.vawizardInfo.vawizard != "undefined") {
            if (this.vawizardInfo.vawizard == "1") {
                this.firstNameValue = this.vawizardInfo.firstname;
                this.lastNameValue = this.vawizardInfo.lastname;
                this.dateOfBirthValue = this.vawizardInfo.dob;
            }
        }
    }

    loadEmailValidation(productName: string, accessKey: string, codeKey: string, resendTimeSpan: number) {

        var validateButton = $("#btnEmailValidate");

        if (validateButton && validateButton.length) {

            validateButton.XapEmailValidate({
                "emailTxtBox": "Email",
                "fistNameTxtbox": "FirstName",
                "lastNameTxtbox": "LastName",
                "productName": productName,
                "screeName": "Account Creation",
                "accessKey": accessKey,
                "codeKey": codeKey,
                "webservice": "/WebServices/EmailValidation.asmx",
                "loaddingImg": "/Home/Wizard/XapEmailValidate/img/loading.gif",
                "resendTimeSpan": resendTimeSpan,
                "deliveryFailedMsg": "The email sent to {0} with the validation code failed to be delivered.<br/> Please make sure the email address is correct and try again.",
                "validationCodeIncorrectMsg": "The validation code you entered is incorrect. Please try entering it again or get a new code by clicking the Resend button above.",
                "resourceId": $("#SchoolId")[0],
                "badDomains": this.config.BadEmailDomain//12920  //25500
            });
        }
    }

    onSubmit(f: NgForm) {

        this.accountCreationService.triggerValidation();
        if (this.config.MobileOptIn) {
            if (this.mobileOptInCheckbox && !this.cellPhoneValidated) {
                f.form.setErrors({ "CellphoneNotValidated": true });
            }
            else {

                if (f.form.errors) {
                    if (f.form.errors["CellphoneNotValidated"]) {
                        delete f.form.errors["CellphoneNotValidated"];
                    }
                    if (!Object.keys(f.form.errors).length) f.form.setErrors(null);
                }
            }
        }

        if (this.config.EmailValidate) {
            if (this.config.EmailValidate.Visible) {
                var unvalidatedEmail = false;
                if (this.socialsignin && this.socialsignin.userid != "" && this.socialsignin.email != "" && this.socialsignin.email != "undefined")
                    unvalidatedEmail = false;
                else {
                        var emailCo = $("#EmailCo").val();
                        unvalidatedEmail = (emailCo != f.controls['Email'].value);
                }

                if (unvalidatedEmail) {
                    f.controls['Email'].setErrors({ "EmailNotValidated": true });
                }
                else {
                    if (f.controls['Email'].errors) {
                        delete f.controls['Email'].errors["EmailNotValidated"];
                        if (f.form.errors) {
                            if (f.form.errors["EmailNotValidated"]) {
                                delete f.form.errors["EmailNotValidated"];
                            }
                            if (!Object.keys(f.form.errors).length) f.form.setErrors(null);
                        }
                     
                        if (!Object.keys(f.controls['Email'].errors).length) f.controls['Email'].setErrors(null);
                    }
                }
                if (f.controls['Email'].errors)
                {
                    if (!$("#btnEmailValidate").hasClass("btn")) {
                        f.controls['Email'].setErrors(null);
                    }
                }                
            }
        }
   
        if (!this.isValidLicence)
        {
            f.form.setErrors({"LicenceNotValidated": true });
        }
        else
        {
            if (f.form.errors) {
                if (f.form.errors["LicenceNotValidated"]) {
                    delete f.form.errors["LicenceNotValidated"];

                }
                if (!Object.keys(f.form.errors).length) f.form.setErrors(null);
            }
        }

   //     console.log(this.config.UseXapEmail)
        if (this.config.UseXapEmail) {
            var useXapEmail = f.form.get('UseXapEmail');
            if (useXapEmail) {
                if (useXapEmail.value && this.config.AccountName.Visible) {
                    if(this.accountNameValue.indexOf("@") > -1)
                    { 
                        //console.log("Errors")
                        this.invalidForm = true;
                       // console.log(f.controls['accountName'])
                      f.controls['accountName'].setErrors({ "isSite": true });
                        this.useSiteChecked = true;
                        return; 
                    }
                    else{
                        this.useSiteChecked = false;
                    }
                }
            }
        }


        if (this.config.Email && this.config.Email.Visible == true && this.emailValue && this.tempEmail != this.emailValue) { 

            this.accountCreationService.doesEmailExist(this.emailValue).subscribe((emailOutPut) => {
                if (emailOutPut == true) {
                    f.controls['Email'].setErrors({
                        "emailExists": true
                    });
                    this.invalidForm = true;
                }
                else {
                    this.submitData(f);
                }
            });
        } else
        {
            this.submitData(f)
        }
    }

    submitData(f: NgForm): void {
        if (f.form.invalid) {
            this.invalidForm = true;
        }

        if (f.form.valid) {
            var apiConfigInstance = ApiConfig.getInstance();
            var sessionVariables = apiConfigInstance.getSession();
            if (this.socialsignin && this.socialsignin.userid != "") {
                var SingInControl = new FormControl(this.socialsignin.tokentype, null);
                var firstNameControl = new FormControl(this.socialsignin.firstname, null);
                var lastNameControl = new FormControl(this.socialsignin.lastname, null);
                var SingInToken = new FormControl(this.socialsignin.token, null);

                var securityQuestion = new FormControl("Account Created by " + this.socialsignin.tokentype, null);
                var securityAnswer = new FormControl(" Use " + this.socialsignin.tokentype + " for password", null);

                f.form.addControl("singintoken", SingInToken);
                f.form.addControl("socialsignintype", SingInControl);
                f.form.addControl("firstName", firstNameControl);
                f.form.addControl("lastName", lastNameControl);

                f.form.addControl("securityQuestion", securityQuestion);
                f.form.addControl("securityAnswer", securityAnswer);

                if (this.socialsignin.email != "" && this.socialsignin.email != "undefined") {
                    this.emailForm = new FormControl(this.socialsignin.email, null);
                    this.emailConfirmationValue = this.socialsignin.email;
                    $("#EmailCo").val(this.socialsignin.email)

                }

                var Userid = new FormControl(this.socialsignin.userid, null);
                var Pwd = new FormControl(this.socialsignin.password, null);
                f.form.addControl("accountName", Userid);
                f.form.addControl("password", Pwd);

                f.form.addControl("passwordConfirmation", Pwd);

            }

            if (this.config.UseXapEmail) {
                var useXapEmail = f.form.get('UseXapEmail');
                if (useXapEmail) {
                    if (useXapEmail.value) {
                        this.emailForm.setValue(this.accountNameValue + "@" + this.domain);
                    }
                }
            }
            f.form.addControl("Email", this.emailForm);
            f.form.addControl("ethnicity", this.ethnicityForm);
            f.form.addControl("native", this.nativeForm);
            f.form.addControl("asian", this.asianForm);
            f.form.addControl("africanAmerican", this.africanAmericanForm);
            f.form.addControl("hawaiian", this.hawaiianForm);
            f.form.addControl("white", this.whiteForm);
            f.form.addControl("choicesUsername", this.choicesNameForm);
            f.form.addControl("choicesPassword", this.choicesPasswordForm);

            // adding in the values that let the api service know if transitons or branded app is hosting this control
            f.form.addControl("systemId", new FormControl(this.systemId, null));
            f.form.addControl("applicationId", new FormControl(this.applicationId, null));
            f.form.addControl("providedResourceId", new FormControl(this.providedResourceId, null));

            if (this.config.MobileOptIn) {
                if (this.config.MobileOptIn.Visible && (this.config.MobileOptIn.Roles.indexOf(this.selectedRoleValue) !== -1)) {
                    f.form.addControl("mobileOptInValue", new FormControl(this.cellPhoneValidated, null));
                }
            }

            if (this.socialsignin && this.socialsignin.userid != "") {
                this.accountNameValue = this.socialsignin.userid
                this.passwordValue = this.socialsignin.password;
                this.passwordConfirmationValue = this.socialsignin.password;
                if (this.socialsignin.email != "" && this.socialsignin.email != "undefined") {
                    this.emailConfirmationValue = this.socialsignin.email;
                }
            }

            if (this.inviteInfo && this.inviteInfo != null) {
                var inviteDetails = new FormControl(this.inviteInfo, null);
                f.form.addControl("inviteDetails", inviteDetails);
            }

            if (this.config.HowHear && this.referredByModel) {

                if (this.referredByModel == "301")
                {
                    var hostname = this.extractHostname(this.referrerUrl);

                    if (this.c2cId != "" && this.howHearSendToXap && this.howHearAllowedDomain.indexOf(hostname) > -1) {
                        f.form.addControl("referrerUserId", new FormControl(this.c2cId, null));
                    }
                    else if (this.howHearGenerateID) {
                        f.form.addControl("referrerUserId", new FormControl("ANSWER_C2C", null));
                    }
                }
                
                //since referredByModel is disabled, we need to add manually to the form
                f.form.addControl("referredByValue", new FormControl(this.referredByModel, null));
            }
            
            f.form.addControl("referrerUrl", new FormControl(this.referrerUrl, null));
            f.form.addControl("loginSource", new FormControl(this.loginSource, null));

            if (this.isExistingUser) {
                f.form.addControl("existingUserId", new FormControl(this.existingUserId, null));
                this.accountCreationService.updateAccount(f.value).subscribe((result) => {
                    this.showResult(result)
                }, (error) => {
                    var myerror = "An unknown error occured while attempting to create the account.";
                    window.location.href = "Account_Creation_Confirmation.aspx?ng=false&existing=true";
                });
            } else {
                this.accountCreationService.createAccount(f.value).subscribe((result) => {
                    this.showResult(result)
                }, (error) => {
                    var myerror = "An unknown error occured while attempting to create the account.";
                    window.location.href = "Account_Creation_Confirmation.aspx?ng=false";
                });
            }            
        }
        else {
            this.accountCreationService.scrollToFirstError();
        }
    }

    showResult(result: any): void {
        if (result.success) {
            if (this.applicationId > 0 || (this.vawizardInfo && this.vawizardInfo.vawizard == "1")) {
                if (this.nextpage != "") {
                    window.location.href = this.nextpage;
                }
                else {
                    window.location.href = "angular_logon.asp";
                }
            }
            else {
                if (this.applicationId == -1) {
                   
                    var querystring = ""
                    if (this.isExistingUser)
                        querystring = "&existing=true"

                    // TODO: get the proper redirect after login and make the condition more generic for a TOP site - Top
                    if (this.currentSiteType == 10) {

                      // set authenitcation cookie
                      this.authService.processUserLogin(new BasicAccountInfo(
                                Number(result.successMsg),
                                this.firstNameValue,
                                this.lastNameValue,
                                true,
                                false,
                                null,
                                ""
                            ), 30, 2, result.accountCreationToken);

                        window.location.href = "/#/Welcome";
                        return;
                    }

                    if (this.inviteInfo && this.inviteInfo != null) {
                        window.location.href = '/your_portfolio/index/Secret_Question.aspx';
                    }
                    else if (this.config.PersonalInfoSharing && this.config.PersonalInfoSharing.Visible && this.personalInfoSharing) {
                        window.location.href = '/Home/Opt_In.aspx?action=toggleoptchoice&destinationURL=/Home/Create_an_Account/Account_Creation_Confirmation.aspx?ng=true' + querystring;
                    }
                    else {
                        window.location.href = 'Account_Creation_Confirmation.aspx?ng=true' + querystring;
                    }
                }
            }

        } else {
            var general = result.errorMsg;

            if (general.indexOf('choices portfolio name') > -1)
                this.choicesUsernameError = true;

            if (general.indexOf('Choices portfolio password') > -1)
                this.choicesPasswordError = true;
        }
    }

    checkIfEmpty(value) {

        return (!value || !value.replace(/\s/g, '').length);
    }

    checkCellPhoneValidity(value) {
        this.mobileOptInCheckbox = false;
        this.cellPhoneValidated = false;
        this.userValidationCode = '';
        this.displayValidationTextbox = false;

        var formattedNumber = value.replace(/[- )(_]/g, '');

        if (formattedNumber.length == 10) {
            this.isCellPhoneValid = true;
        }
        else {
            this.isCellPhoneValid = false;
        }
    }

    toggleVerification() {
        if (!this.mobileOptInCheckbox && !this.cellPhoneValidated) {
            this.enableMobileValidationButton = true;
        }
        else {
            this.userValidationCode = '';
            this.enableMobileValidationButton = false;
            this.displayValidationTextbox = false;
            this.cellPhoneValidated = false;
        }
    }

    checkValidationCode(userValidationCode) {
        if (userValidationCode == this.validationCode) {
            this.cellPhoneValidated = true;
            this.displayValidationError = false;
            this.displayValidationTextbox = false;
        }
        else {
            this.displayValidationError = true;
        }
    }

    cancelValidation() {
        this.userValidationCode = '';
        this.displayValidationTextbox = false;
        this.displayValidationError = false;
        this.cellPhoneValidated = false;
        this.mobileOptInCheckbox = false;
    }

    generateValidationCode(size) {
        let digit: number, stringCode: string = '';

        for (var i = 0; i < size; i++) {
            digit = Math.floor(Math.random() * 10);
            stringCode = stringCode + digit.toString();
        }

        return stringCode;
    }

    sendValidationCode() {
        if (!this.cellPhoneValidated) {
            this.validationCode = this.generateValidationCode(4);
            this.displayValidationTextbox = true;
            this.accountCreationService.sendValidationCode(this.validationCode, this.cellphone, this.systemId, this.applicationId).subscribe((output) => {
            });
        }
    }

    populateTypeAheadSchoolArray(json: any) {
        var items = [];

        if (json.length) {

            for (let item of json) {
                items.push({ label: item.Name, value: item.Id })
            }
        }

        return items;
    }

    updateSchool(event: any) {
        this.isValidLicence = true;
        if (event[0]) {
           this.selectedSchool = this.SchoolList.find(entry => {
               return entry.Id == event[0].id;
            });
           this.checkCoppaDate();
           if (this.selectedSchool.IsCoppaEnabled == false)
           {
               this.isCoppaRestricted = false;
           }
           if (this.selectedSchool.IsLicenseEnabled) {
               this.accountCreationService.setResourceId(event[0].id).subscribe((output) => {
                 if (output) {
                   if (!this.sessionVariables.systemInfo.existingUserName || this.sessionVariables.systemInfo.existingUserName == "") {
                     this.refreshConfigList();
                   }
                 }
               });
           }
           else {
               // show message
               this.isValidLicence = false
              
           }
        }
    }

    submitActivationCode() {
        //this.systemKey = 'FL01108';
        this.accountCreationService.setActivationCode(this.systemKey).subscribe((output) => {
            if (output > 0) {
                if (this.isExistingUser) {
                    this.refreshSchoolList();
                }

                this.refreshConfigList();
                this.isCodeActivated = true;
            }
            else
                this.isInvalidActivationCode = true;
        });
    }

    onEnterKey(event: any) {

        if (event.keyCode == 13) {
            if (this.config.SystemKey) {
                if (!this.isCodeActivated && this.config.SystemKey.Visible) {
                    this.submitActivationCode();
                    event.preventDefault();
                }
            }
        }
    }

    stringIt(obj: any) {

        return JSON.stringify(obj);
    }

    PermAddressForMailingChecked(e): void {

        //TODO: declare the fields and access thru typescript and finish off this method when mailing address needs to be implemented for a client
        var isChecked = e.target.checked;

        if (isChecked) {
            $('#MailingAddress').val($("#Address").val());
            $('#MailingCity').val($("#City").val());

            this.statePickerHelper.cleanValue = ["CO"];

            $('#MailingStateChoice').val($("#stateChoice").val());
            $('#MailingZip').val($("#Zip").val());
            $('#MailingCounty').val($("#County").val());
            $('#MailingCountryChoice').val($("#countryChoice").val());
            $('#mailingInternationalPostalCode').val($("#InternationalPostalCode").val());
        }
        else {
            $('#MailingAddress').val('');
            $('#MailingCity').val('');
            $('#MailingStateChoice').val('');
            $('#MailingZip').val('');
            $('#MailingCounty').val('');
            $('#MailingCountryChoice').val('');
            $('#mailingInternationalPostalCode').val('');
        }
    }

    schoolNotInList(helper: Ng2SelectMultiHelper) {
        var numberCopy = JSON.parse(JSON.stringify(this.defaultResourceId));
        helper.setSelectedItem(numberCopy, 'Not on the list');
        this.selectedResourceId = numberCopy;
    }

    checkCoppaDate() {

        if (this.config.CoppaRestricted) {
            if (!this.config.CoppaRestricted.Required) {

                var underThirteen = false;
                var dob = this.dateOfBirthValue;
                if (dob != null) {
                    var timestamp = Date.parse(dob);

                    if (!isNaN(timestamp)) {
                        var date = new Date(dob);
                      if (this.calculateAge(date) < 13) { 
                        underThirteen = true;
                      }
                      else
                      {
                        underThirteen = false;
                        if ((this.selectedRoleId == 3) || (this.selectedRoleId == 4) || (this.selectedRoleId == 5)) { 
                          this.dateOfBirthValue = ""; 
                          this.isCoppaRestricted = false;
                        }
                       // console.log('1272 ' + underThirteen);
                      }
                    }
                }

                if (this.selectedSchool) {
                    if (this.selectedSchool.IsCoppaEnabled == true) {
                        this.isCoppaRestricted = underThirteen;
                    }
                }
                else {
                    if (this.selectedResourceId && this.selectedResourceId > 0) {
                        this.isCoppaRestricted = underThirteen;
                        if (this.currentSystemName != 'Transcript Ordering Portal') {
                            this.accountCreationService.GetSchoolInfo(this.selectedResourceId.toString()).
                                subscribe((schoolInfo) => {
                                    if (schoolInfo.IsCoppaEnabled == true)
                                        this.isCoppaRestricted = underThirteen;
                                });
                        }
                        else { 
                            this.accountCreationService.GetSchoolInfoByResourceId(this.selectedResourceId.toString()).
                            subscribe((schoolInfo) => {
                                if (schoolInfo.IsCoppaEnabled == true)
                                    this.isCoppaRestricted = underThirteen;
                            });
                        }
                    }
                    else {
                        this.isCoppaRestricted = underThirteen;
                    }
                }
            }
        }
    }

    isAboveThirteen(): boolean {
        let aboveThirteen = false;

        if (this.dateOfBirthValue == null) return aboveThirteen;
        if (isNaN(Date.parse(this.dateOfBirthValue))) return aboveThirteen;

        let age = this.calculateAge(new Date(this.dateOfBirthValue))
        aboveThirteen = (age >= 13);

        return aboveThirteen;
    }

    calculateAge(birthday: Date) { // birthday is a date
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    onEthnicityChange(newValue) {
        if (newValue != 'nonHispanic') {
            this.native = false;
            this.asian = false;
            this.africanAmerican = false;
            this.hawaiian = false;
            this.white = false;
        }
    }

    onRoleChange() {
        switch (this.selectedRoleValue) {
          case this.RolesEnum.MiddleSchool:
            this.selectedRoleId = 1;
            break
          case this.RolesEnum.HighSchool:
            this.selectedRoleId = 2;
            break
          case this.RolesEnum.PostSecondary:
            this.selectedRoleId = 3;
            this.isCoppaRestricted = false;
            if (this.dateOfBirthValue !== "") this.dateOfBirthValue = "";
            break
          case this.RolesEnum.Adult:
            this.selectedRoleId = 4;
            if (this.dateOfBirthValue !== "") this.dateOfBirthValue = "";
            this.isCoppaRestricted = false;
            break
          case this.RolesEnum.Parent:
            this.selectedRoleId = 5;
            if (this.dateOfBirthValue !== "") this.dateOfBirthValue = "";
            this.isCoppaRestricted = false;
            break
          default:
            this.selectedRoleId = -1
            this.isCoppaRestricted = false;
            break
        }
        this.refreshSchoolList();
//console.log(this.config.HowHear)
        if (this.sessionVariables.systemInfo.existingUserName && this.sessionVariables.systemInfo.existingUserName != "") {
          if (this.dateOfBirthValue == null || this.dateOfBirthValue == "") {
            this.configureConfig(false);


          }
        }
      if (this.config.UserRole.Required)
      this.config.UserRole.Visible = true;
      if (this.config.HowHear.Required)
        this.config.HowHear.Visible = true;
    }

    getDDDateYear() {
        var d = new Date();
        var currentYear = d.getFullYear();
        var currentMonth = d.getMonth();

        if (currentMonth > 5)
            currentYear = currentYear + 1;

        return currentYear;
    }

    getGradeYearByGradYear(gradYear) {

        var d = new Date();
        var currentYear = this.getDDDateYear();
        var grade = 12;
        var gradeLabel;

        if (gradYear == currentYear)
            gradeLabel = "a " + grade + "th";

        if (gradYear == (currentYear + 1))
            gradeLabel = "an " + (grade - 1) + "th";

        if (gradYear == (currentYear + 2))
            gradeLabel = "a " + (grade - 2) + "th";

        if (gradYear == (currentYear + 3))
            gradeLabel = "a " + (grade - 3) + "th";

        if (gradYear == currentYear)
            gradeLabel = "a " + grade + "th";

        if (gradYear == (currentYear + 4))
            gradeLabel = "an " + (grade - 4) + "th";

        if (gradYear == (currentYear + 5))
            gradeLabel = "a " + (grade - 5) + "th";

        if (gradYear == (currentYear + 6))
            gradeLabel = "a " + (grade - 6) + "th";

        if (gradYear == (currentYear + 7))
            gradeLabel = "a " + (grade - 7) + "th";

        if (gradYear == (currentYear + 8))
            gradeLabel = "a " + (grade - 8) + "th";

        if (gradYear == (currentYear + 9))
            gradeLabel = "a " + (grade - 9) + "rd";

     //   if (gradYear == (currentYear + 10))
      //      gradeLabel = "a " + (grade - 10) + "nd";

        // only show the grade year text to high school and middle school roles
        if (this.selectedRoleValue == "ms" || this.selectedRoleValue == "hs") {

            return gradYear + " - You are " + gradeLabel + " grade student";
        }
        return gradYear;;
    }

    setPrivacyTermsLink(link, name): void {
        this.privacyLink = <HTMLAnchorElement>document.getElementById(name);
        this.privacyLink.href = link;
    }

    updateEmail(formControl): void {
        this.emailValue = formControl.warnings;
        formControl.warnings = undefined;
    }

     extractHostname(url) {
         var hostname;

        //find & remove protocol (http, ftp, etc.) and get hostname
        if (url.indexOf("://") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }

        //find & remove port number
         hostname = hostname.split(':')[0];

        //find & remove "?"
        hostname = hostname.split('?')[0];

        return hostname;
    }
}
